import { Route, Routes, useNavigate } from 'react-router-dom';
import { WorkOSAuthProvider } from '@weareopenr/authkit';
import { HeaderSnackbarProvider } from '@weareopenr/component-library';
import '@weareopenr/component-library/build/global.scss';
import './styles/global.scss';
import { Welcome } from './pages';
import Layout from './components/Layout/Layout';
import { EnvironmentProvider } from './hooks';
import { ThemeProvider } from './theme';

const AppRoutes = () => (
  <HeaderSnackbarProvider>
    <Routes>
      <Route path="/login" element={<Welcome />} />
      <Route path="/*" element={<Layout />} />
    </Routes>
  </HeaderSnackbarProvider>
);

const App = (): React.ReactElement => {
  const navigate = useNavigate();
  return (
    <WorkOSAuthProvider
      clientId={process.env.REACT_APP_WORKOS_CLIENT_ID || ''}
      onRedirectCallback={({ state }) => {
        navigate(state?.returnTo || '/', { replace: true });
      }}
    >
      <ThemeProvider>
        <EnvironmentProvider>
          <AppRoutes />
        </EnvironmentProvider>
      </ThemeProvider>
    </WorkOSAuthProvider>
  );
};

export default App;
